import Stack from '@mui/material/Stack'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { useMemo } from 'react'
import { routes } from '@/router'
import { matchPath, useLocation } from 'react-router-dom'
import { QontoConnector, StepIcon } from './stepper.icon'
import { useMediaQuery } from '@mui/material'

// hiring step label
const stepLabels = ['Sócio', 'Empresa', 'Documentos']

export const HiringStepper = () => {
  const location = useLocation()
  const isMobile = useMediaQuery('(max-width: 600px)')
  // Map routes to step indices
  const routeToStepIndex = {
    [routes.hiring.mainPartner]: 0,
    [routes.hiring.company]: 1,
    [routes.hiring.documents]: 2,
  }
  // active step based on the current route
  const activeStep = useMemo(() => {
    const matchingRoute = Object.entries(routeToStepIndex).find(([route]) =>
      matchPath(route, location.pathname),
    )

    // corresponding step index
    return matchingRoute !== undefined ? matchingRoute[1] : 0
  }, [location.pathname])

  return (
    <Stack sx={{ width: isMobile ? '100%' : '60%' }} mt={4}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
      >
        {stepLabels.map((label) => (
          <Step key={label}>
            <StepLabel slots={{ stepIcon: StepIcon }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  )
}
